<template lang="pug">
  div
    div.container-fluid.px-0
      div.top-buttons-menu.d-flex(v-if="showToolbar")
        button.btn.btn-primary(
          v-if="canShowMenu"
          @click="showMenu"
          :disabled="disableNavigation"
          )
          svg(viewBox="0 0 24 24")
            path(fill="white" d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z")
          span.ml-2 Menü
        div.flex-fill
        button.btn.btn-secondary.ml-2(
          v-if="canChangePassword"
          @click="changePassword"
          :disabled="disableNavigation"
          )
          svg(viewBox="0 0 24 24")
            path(fill="white" d="M12.63,2C18.16,2 22.64,6.5 22.64,12C22.64,17.5 18.16,22 12.63,22C9.12,22 6.05,20.18 4.26,17.43L5.84,16.18C7.25,18.47 9.76,20 12.64,20A8,8 0 0,0 20.64,12A8,8 0 0,0 12.64,4C8.56,4 5.2,7.06 4.71,11H7.47L3.73,14.73L0,11H2.69C3.19,5.95 7.45,2 12.63,2M15.59,10.24C16.09,10.25 16.5,10.65 16.5,11.16V15.77C16.5,16.27 16.09,16.69 15.58,16.69H10.05C9.54,16.69 9.13,16.27 9.13,15.77V11.16C9.13,10.65 9.54,10.25 10.04,10.24V9.23C10.04,7.7 11.29,6.46 12.81,6.46C14.34,6.46 15.59,7.7 15.59,9.23V10.24M12.81,7.86C12.06,7.86 11.44,8.47 11.44,9.23V10.24H14.19V9.23C14.19,8.47 13.57,7.86 12.81,7.86Z")
          span.ml-2 Kennwort ändern
        button.btn.btn-secondary.ml-2(
          v-if="canLogout"
          @click="logout"
          :disabled="disableNavigation"
          )
          span.mr-2 Abmelden
          svg(viewBox="0 0 24 24")
            path(fill="white" d="M14.08,15.59L16.67,13H7V11H16.67L14.08,8.41L15.5,7L20.5,12L15.5,17L14.08,15.59M19,3A2,2 0 0,1 21,5V9.67L19,7.67V5H5V19H19V16.33L21,14.33V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19Z")
    router-view
</template>

<script>
import { mapState, mapActions } from 'vuex'

import store from '@/store'
import router from './router'
import registerServices from '@/services'
import { getDisplayMode } from '@/displayMode'

// IMPORTANT: register services outside of component, immediately after import of store
// Otherwise the components do not have the state.orderFormService defined and will error it
registerServices(store)

export default {
  name: 'OrdersContainer',
  store: store,
  router: router,
  data () {
    return {
      displayMode: getDisplayMode()
    }
  },
  computed: {
    ...mapState('authentication', [
      'authenticated'
    ]),
    ...mapState({
      disableNavigation: state => !!state.orderFormService.loadingIndicators.createOrder
    }),
    canChangePassword () {
      return this.canLogout && this.$route.name !== 'set-password'
    },
    canLogout () {
      return this.authenticated
    },
    canShowMenu () {
      return this.authenticated && this.$route.name !== 'menu'
    },
    showToolbar () {
      if (this.displayMode === 'studentRegistration') {
        return false
      }
      return this.authenticated && this.$route.name !== 'index'
    }
  },
  mounted () {
    if (this.displayMode === 'studentRegistration') {
      if (this.$route.name !== 'student-registration' && this.$route.name !== 'student-verification' && !this.authenticated) {
        this.$router.push({ name: 'student-registration' })
      }
    }
  },
  methods: {
    ...mapActions('authentication', [
      'logout'
    ]),
    ...mapActions('ui', [
      'changePassword',
      'showStartPage',
      'showMenu'
    ])
  }
}
</script>

<style lang="stylus">
  html
    font-size 14px

  // added because of Safari issue (in Bootstrap this is def through @supports)
  .sticky-top
    position sticky
    top 25px
    z-index 1020

  .no-wrap
    white-space nowrap

  .vertical-center
    display flex
    align-items center
    // min-height 100vh

    .row
      width 100vw

  .top-buttons-menu
    padding 10px 0px

    button.btn
      display flex
      align-items center

      svg
        width 24px
        height 24px

  button.btn.btn-icon
    display inline-flex
    align-items center

    svg
      width 24px
      height 24px

  .card
    background-color rgba(255, 255, 255, 0.5)

    .card-header
      background-color rgba(255, 255, 255, 0.8)
      font-weight bold
      font-size 120%

  .spinner
    width 64px
    height 64px
    position absolute
    top calc(50% - 32px)
    left calc(50% - 32px)

    &.spinner-border
      border 0.25em solid currentColor
      border-right-color transparent

  .invisible
    visibility hidden

  .fat-checkbox
    font-size 125%
    font-weight bold

  .min-height
    min-height 400px
</style>
